<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <card header-classes="bg-transparent">

            <div class="card">
                <div class=" card-header">
                    <h2 class="card-title">Mid Term Mark Record</h2>
                </div>
                <div class="card-body">
                    <div class="form-inline text-center">
                        <select v-model="RegisteredTermIdVal" class="form-control ml-3"
                            :disabled="RegisteredTerms === null">
                            <option value="0">{{ RegisteredTerms === null ? '⏳ Loading...' : '- Select Registered Term-'
                            }}</option>
                            <option v-for="item in RegisteredTerms" :key="item.registeredTermId"
                                v-bind:value="item.registeredTermId">
                                {{ item.schSession }} - {{ item.schTerm }}
                            </option>
                        </select>
                        <select v-model="ClassIdval" class="form-control ml-3" @change="getoptioninsubjectassigned()"
                            :disabled="classitems === null">
                            <option value="0">{{ classitems === null ? '⏳ Loading...' : '- Select Class -' }}</option>
                            <option v-for="item in classitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.Sch_Class }}
                            </option>
                        </select>
                        <select v-model="OptionIdval" class="form-control ml-3" @change="getarminsubjectassigned()"
                            :disabled="optionitems === null">
                            <option value="0">{{ optionitems === null ? '⏳ Loading...' : '- Select Option -' }}</option>
                            <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.ClassOption }}
                            </option>
                        </select>
                        <select v-model="ArmIdval" class="form-control ml-3" @change="getsubjectinsubjectassigned()"
                            :disabled="armitems === null">
                            <option value="0">{{ armitems === null ? '⏳ Loading...' : '- Select Arm -' }}</option>
                            <option v-for="item in armitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.SectionName }}
                            </option>
                        </select>
                        <select v-model="SubjectIdval" class="form-control ml-3" @change="GetStudentForMarkRecord()"
                            :disabled="subjectitems === null">
                            <option value="0">{{ subjectitems === null ? '⏳ Loading...' : '- Select Subject -' }}
                            </option>
                            <option v-for="item in subjectitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.SchSubject }}
                            </option>
                        </select>
                    </div>
                    <div class="table-responsive mt-2">
                        <table class="table table-borderless table-striped table-hover table-sm">
                            <thead>
                                <tr>
                                    <th>Admission Number</th>
                                    <th>Student Name</th>
                                    <th>Obtainable Score</th>
                                    <th>Score</th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="student in markRecordItem" :key="student.studentId">
                                    <td class="align-middle" data-label="Admission Number">{{ student.admNo }}</td>
                                    <td class="align-middle" data-label="Student Name">{{ student.studentName }}</td>
                                    <td class="align-middle" data-label="Obtainable Score">{{
                                        student.obtainableMidTermScore }}
                                    </td>
                                     <td class="align-middle" data-label="Score">
                                        <input type="number" class="form-control" v-model.number="student.score"
                                            :max="student.obtainableMidTermScore" @change="validateScore(student)" />
                                    </td>                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center mb-3" v-if="markRecordItem">
                        <button type="submit" class="btn btn-primary my-4" @click.prevent="submitdata">Submit</button>
                    </div>
                </div>
            </div>
        </card>
    </div>
</template>
<script>
import moment from 'moment'
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: 'MarkRecord',
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner,
    },
    data() {
        return {
            dataid: 1,
            ClassIdval: 0,
            OptionIdval: '',
            ArmIdval: '',
            SessionIdval: '',
            TermIdval: '',
            SubjectIdval: '',
            RegisteredTermIdVal: 0,
            classitems: null,
            optionitems: null,
            armitems: null,
            subjectitems: null,
            studentItem: null,
            RegisteredTerms: null,
            onloader: 'none',
            markRecordItem: null,
        }
    },
    methods: {
        validateScore(student) {
            if (student.score > student.obtainableMidTermScore) {
                student.score = student.obtainableMidTermScore;
                this.ShowAlertWarning('Invalid Input', `Score cannot exceed Obtainable Score (${student.obtainableMidTermScore}). Value has been reset.`);
            }
        },       
        submitdata() {
            const markRecordList = (this.markRecordItem || [])
                .filter(student => Number(student.score) > 0)
                .map(student => ({
                    StudentId: student.studentId,
                    Score: student.score,
                }));

            if (markRecordList.length === 0) {
                this.ShowAlertWarning('No records to submit', 'Only students with Score > 0 will be submitted.');
                return;
            }

            let sectionId = this.ArmIdval;
            let registeredTermId = this.RegisteredTermIdVal;
            let subjectId = this.SubjectIdval;
            let userdata = {
                sectionId,
                registeredTermId,
                subjectId,
                markRecordList
            }
            this.onloader = 'flex'
            this.$store.dispatch('PortalMarkRecord/CreateMarkRecordMidTerm', userdata)
                .then((resp) => {
                    if (resp.responseCode !== "00") {
                        this.onloader = 'none'
                        this.ShowAlertError(resp.responseMessage, '');
                        return;
                    }
                    this.onloader = 'none'
                    this.ShowAlertSuccess("Submitted successfully", '');
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getclassinsubjectassigned() {
            this.classitems = null;
            this.studentItem = null;
            this.optionitems = null;
            this.armitems = null;
            this.subjectitems = null;
            this.markRecordItem = null;
            this.ClassIdval = 0;
            this.onloader = 'flex'
            this.$store.dispatch('getclassinsubjectassigned')
                .then(resp => {
                    this.classitems = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getoptioninsubjectassigned() {
            this.studentItem = null;
            this.optionitems = null;
            this.armitems = null;
            this.subjectitems = null;
            this.markRecordItem = null;
            this.OptionIdval = 0;
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.onloader = 'flex'
                this.$store.dispatch('getoptioninsubjectassigned', ClassId)
                    .then(resp => {
                        this.optionitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        getarminsubjectassigned() {
            this.studentItem = null;
            this.armitems = null;
            this.subjectitems = null;
            this.markRecordItem = null;
            this.ArmIdval = 0;
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.onloader = 'flex'
                this.$store.dispatch('getarminsubjectassigned', OptionId)
                    .then(resp => {
                        this.armitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        getsubjectinsubjectassigned() {
            this.studentItem = null;
            this.subjectitems = null;
            this.markRecordItem = null;
            this.SubjectIdval = 0;
            let ArmId = this.ArmIdval;
            if (ArmId > 0) {
                this.onloader = 'flex'
                this.$store.dispatch('getschsubjectinsubjectassigned', ArmId)
                    .then(resp => {
                        this.subjectitems = resp;
                        this.onloader = 'none';
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }
        },
        GetStudentForMarkRecord() {
            if (this.ArmIdval > 0 && this.RegisteredTermIdVal > 0 && this.SubjectIdval > 0) {
                let SectionId = this.ArmIdval;
                let RegisteredTermId = this.RegisteredTermIdVal;
                let SubjectId = this.SubjectIdval;
                let userdata = {
                    SectionId,
                    RegisteredTermId,
                    SubjectId
                }
                this.onloader = 'flex'
                this.$store.dispatch('PortalMarkRecord/GetStudentForMarkRecordMidTerm', userdata)
                    .then((resp) => {
                        if (resp.responseCode === "00") {
                            this.markRecordItem = resp.data;
                        } else {
                            this.markRecordItem = null;
                        }
                        this.onloader = 'none'
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }

        },
        GetPortalRegisteredTerm() {
            let userdata = {
                SearchValue: null,
                PageNumber: 1,
                PageSize: 100
            }
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("PortalSchoolSessionTerm/GetPortalRegisteredTerm", userdata)
                .then((resp) => {
                    this.RegisteredTerms = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        frontEndDateFormat(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat(date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },
    },
    mounted() {
        this.GetPortalRegisteredTerm();
        this.getclassinsubjectassigned();
    }
};
</script>


<style scoped>
/* Mobile-friendly table: stack rows as cards below 576px */
@media (max-width: 576px) {
    .table-responsive table thead {
        display: none;
    }

    .table-responsive table,
    .table-responsive table tbody,
    .table-responsive table tr,
    .table-responsive table td {
        display: block;
        width: 100%;
    }

    .table-responsive table tr {
        margin-bottom: 0.75rem;
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 0.5rem;
        border-radius: 6px;
        background: #fff;
    }

    .table-responsive table td {
        padding: 0.25rem 0.5rem;
        text-align: right;
        position: relative;
    }

    .table-responsive table td::before {
        content: attr(data-label) ": ";
        float: left;
        font-weight: 600;
        text-transform: none;
        color: #495057;
    }

    .form-control,
    .form-control-sm {
        width: 100%;
    }
}
</style>